import React from 'react';
import Letter from './Letter'
import './Fillword.css';

class Fillword extends React.Component {
  constructor (props) {
    super(props);

    /**
     * Список цветов для подсвечивания каждого следующего слова
     *
     * @type {string[]}
     */
    if(this.props.colorList) {
      this.colorList = this.props.colorList;
    } else {
      this.colorList = [
        '#00149f',
        '#3c9f5c',
        '#9f7152',
        '#c4557f',
        '#96239f',
        '#889f10',
      ].sort(() => .5 - Math.random());
      this.colorList.unshift('');
    }

    this.state = {
      mouseDown: false,
      currentLetter: null,
      currentWord: [],
      words: [],
      cells: [],
    };
  }

  /**
   * Очищает поле от подсвеченных при наведении букв
   * (устанавливает .word=-1 для .selected = false
   */
  clearSelection () {
    this.setState({
      cells: this.state.cells.map(row => {
        return row.map(cell => {
          cell.word = cell.selected ? cell.word : -1;
          return cell;
        })
      })
    });
  }

  /**
   * Перед монтированием создаём двумерный массив с
   * объектами букв.
   */
  componentWillMount() {
    let cells = [], k = 0;
    this.props.rows.forEach((row, i) => {
      cells.push([]);
      row.forEach((cell, j) => {
        cells[i].push({
          /** .selected = true при подтверждении слова */
          selected: false,
          /** .letter - буква */
          letter: cell,
          /** .word = индекс слова, -1 - нет слова */
          word: -1,
          /** что-то вроде ... slug? */
          key: k++,
        });
      });
    });

    this.setState({
      cells
    });
  }

  /**
   * Callback-функция при наведении на букву
   * @param v
   */
  currentLetter(v) {
    this.setState({
      currentLetter: v
    });
    if(this.state.mouseDown) {
      this.addLetter(v);
    }
  }

  /**
   * Добавляет букву в текущий набор-слово
   *
   * @param v
   * @returns {boolean}
   */
  addLetter(v) {
    if(!v) return;

    if(this.state.cells[v[0]][v[1]].selected) {
      return true;
    }

    if(this.state.cells[v[0]][v[1]].word > -1) {
      return true;
    }

    /**
     * Что бы выделять только те, что можно
     */
    if(this.state.currentWord.length > 0) {
      let lastItem = this.state.currentWord[this.state.currentWord.length - 1];
      let allowed = [
        [lastItem[0] + 1, lastItem[1]],
        [lastItem[0], lastItem[1] + 1],
        [lastItem[0] - 1, lastItem[1]],
        [lastItem[0], lastItem[1] - 1],
      ];
      let isAllowed = false;

      allowed.forEach(cell => {
        if(cell[0] === v[0] && cell[1] === v[1]) {
          isAllowed = true;
        }
      });

      if(!isAllowed) {
        return true;
      }
    }

    let cells = this.state.cells;
    cells[v[0]][v[1]].word = this.state.words.length;

    this.setState({
      currentWord: this.state.currentWord.concat([v]),
      cells: cells,
    });
  }

  touchStart (e) {
    let key = this._elementKey(e.target);
    this.setState({
      mouseDown: true
    }, () => {
      this.currentLetter(key);
    });

  }

  mouseDown (e) {
    this.setState({mouseDown: true})
    if(this.state.currentLetter !== null) {
      this.addLetter(this.state.currentLetter);
    } else if (e.target.getAttribute('data-key').length > 0) {
      this.currentLetter(e.target.getAttribute('data-key').split('-'));
    }
  }
  mouseUp () {
    let word = this.state.currentWord;

    this.setState({
      mouseDown: false,
      currentWord: [],
    });

    if(this.checkWord(word)) {
      if((this.state.words.length + 1) === (this.props.words.length)) {
        this.props.onComplete && this.props.onComplete();
      }
    } else {
      this.clearSelection();
    }
  }

  /**
   * Сравнивает, есть ли в списке слов выделенное слово
   *
   * @param list
   * @returns {boolean}
   */
  checkWord (list) {
    if(list !== null && list.length > 0) {
      /*
       * If you want create an array with the right word (PHP)
        console.log(
          `[[${list.map(row => row.join(',')).join('],[')}]],`
        );
       */
      var index = this.props.words.indexOf(list.map(row => row.join('')).join(''));
      if(index > -1) {
        let arr = this.state.cells,
            word = this.state.words.length + 1;

        list.forEach(cell => {
          arr[cell[0]][cell[1]].word = word;
          arr[cell[0]][cell[1]].selected = true;
        });

        this.setState({
          words: this.state.words.concat(index),
          cells: arr
        });

        this.props.onWord && this.props.onWord();

        return true;
      }
    }

    return false;
  }

  render() {
    let width = (this.props.size + 2) * this.state.cells.length + 0.5*this.props.size;

    let style = {width};

    return (
      <div
        className="fillword-board"
        style={style}
        onTouchMove={this.touchMove.bind(this)}
        onTouchStart={this.touchStart.bind(this)}
        onMouseDown={this.mouseDown.bind(this)}
        onTouchEnd={this.mouseUp.bind(this)}
        onMouseUp={this.mouseUp.bind(this)}
        onMouseLeave={this.mouseUp.bind(this)}
        onMouseEnter={this.mouseUp.bind(this)}
      >
        {this.state.cells.map((row, i) => {
          return (
            <div className="fillword-row" key={i} style={{height:this.props.size}}>{row.map((cell, j) => {
              var bindMouse = this.currentLetter.bind(this, [i, j]);

              var bgColor;
              if(cell.selected) {
                bgColor = this.colorList[cell.word];
              } else {
                bgColor = this.colorList[cell.word + 1];
              }


              return (
                <Letter
                  size={this.props.size}
                  bgColor={bgColor}
                  mouseEnter={bindMouse}
                  Letter={cell.letter}
                  key={cell.key}
                  slug={[i,j].join('-')}
                />
              )
            })}</div>
          )
        })}
      </div>
    );
  }

  touchMove (e) {
    let touch = e.targetTouches[0];
    let key = this._elementKey(document.elementFromPoint(touch.clientX, touch.clientY));
    this.currentLetter(key);
  }

  _elementKey (e) {
    return e.getAttribute('data-key') &&
      e.getAttribute('data-key').split('-').map(e => parseInt(e));
  }
}

export default Fillword;